'use strict';

var _ = require('lodash');
var AuthenticationTokenService = function AuthenticationTokenService() {
  //TODO: These are all stub functions until a true authentication loop is established with the
  //real authentication process.
  var authTokenData = require('../config/authTokenData.json');
  function getFakeTokenForUser(userInformation) {
    var userId = userInformation ? userInformation.userId : null;
    var authorizedUser = authTokenData.filter(function (user) {
      return user.userId === userId;
    });
    if (authorizedUser.length > 0) {
      return authorizedUser[0].authenticationToken;
    }
    return null;
  }
  function getUserFromToken(userToken) {
    var userInformation = _.find(authTokenData, {
      authenticationToken: userToken
    });
    if (!userInformation) {
      return authTokenData[0];
    }
    return userInformation;
  }
  return {
    getFakeTokenForUser: getFakeTokenForUser,
    getUserFromToken: getUserFromToken
  };
};
module.exports = AuthenticationTokenService;